"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMS_PLUGIN_ID = exports.PAGE_LINK_PLUGIN_ID = exports.SHARED_PLUGIN_ID = exports.MULTILINGUAL_PLUGIN_ID = exports.UrlizedFormat = exports.URLIZED_PLUGIN_ID = exports.SINGLES_PLUGIN_ID = exports.GRID_APPLESS_PLUGIN_ID = exports.PublishingStatus = exports.DRAFT_DATE_FIELD_KEY = exports.PUBLISH_DATE_FIELD_KEY = exports.PUBLISH_STATUS_FIELD_KEY = exports.PUBLISHING_PLUGIN_ID = void 0;
exports.PUBLISHING_PLUGIN_ID = 'publishing';
exports.PUBLISH_STATUS_FIELD_KEY = '_publishStatus';
exports.PUBLISH_DATE_FIELD_KEY = '_publishDate';
exports.DRAFT_DATE_FIELD_KEY = '_draftDate';
var PublishingStatus;
(function (PublishingStatus) {
    PublishingStatus["DRAFT"] = "DRAFT";
    PublishingStatus["PUBLISHED"] = "PUBLISHED";
})(PublishingStatus = exports.PublishingStatus || (exports.PublishingStatus = {}));
exports.GRID_APPLESS_PLUGIN_ID = 'gridAppless';
exports.SINGLES_PLUGIN_ID = 'singleItem';
exports.URLIZED_PLUGIN_ID = 'urlized';
var UrlizedFormat;
(function (UrlizedFormat) {
    UrlizedFormat["PLAIN"] = "plain";
    UrlizedFormat["ORIGINAL"] = "original";
})(UrlizedFormat = exports.UrlizedFormat || (exports.UrlizedFormat = {}));
exports.MULTILINGUAL_PLUGIN_ID = 'multilingual';
exports.SHARED_PLUGIN_ID = 'shared';
exports.PAGE_LINK_PLUGIN_ID = 'persistentPageLink';
exports.CMS_PLUGIN_ID = 'cms';
//# sourceMappingURL=plugins.js.map